// src/pages/legal/AccountDeletion.jsx
import { useState } from "react";

export default function AccountDeletion() {
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    reason: "",
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const update = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/account-deletion/request`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
        },
      );

      const data = await res.json();

      if (!res.ok) throw new Error(data.message);

      setMessage(data.message);
      setForm({ fullName: "", email: "", phoneNumber: "", reason: "" });
    } catch (err) {
      setMessage(err.message || "Unable to submit request.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main style={styles.page}>
      <section style={styles.card}>
        <h1 style={styles.title}>Account Deletion Request</h1>
        <h2 style={styles.subtitle}>Demande de suppression de compte</h2>

        <p style={styles.text}>
          You may request deletion of your NGC Financial account and associated
          personal data. Some financial, transaction, KYC, fraud-prevention, tax
          or compliance records may be retained where required by law.
        </p>

        <p style={styles.text}>
          Vous pouvez demander la suppression de votre compte NGC Financial et
          des données personnelles associées. Certaines données financières,
          transactionnelles, KYC, fiscales ou de conformité peuvent être
          conservées lorsque la loi l’exige.
        </p>

        <form onSubmit={submit} style={styles.form}>
          <input
            name="fullName"
            placeholder="Full name / Nom complet"
            value={form.fullName}
            onChange={update}
            required
            style={styles.input}
          />

          <input
            name="email"
            type="email"
            placeholder="Account email / Email du compte"
            value={form.email}
            onChange={update}
            required
            style={styles.input}
          />

          <input
            name="phoneNumber"
            placeholder="Phone number / Numéro de téléphone"
            value={form.phoneNumber}
            onChange={update}
            style={styles.input}
          />

          <textarea
            name="reason"
            placeholder="Reason / Motif"
            value={form.reason}
            onChange={update}
            rows={5}
            style={styles.textarea}
          />

          <button disabled={loading} style={styles.button}>
            {loading ? "Submitting..." : "Submit request"}
          </button>
        </form>

        {message && <p style={styles.message}>{message}</p>}

        <p style={styles.contact}>
          You can also contact us at{" "}
          <strong>support@ngcfinancialservices.com</strong>.
        </p>
      </section>
    </main>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background: "#f8fafc",
    padding: "48px 16px",
  },
  card: {
    maxWidth: 760,
    margin: "0 auto",
    background: "#fff",
    borderRadius: 28,
    padding: "clamp(24px, 5vw, 44px)",
    boxShadow: "0 24px 70px rgba(15,23,42,0.12)",
    border: "1px solid #e2e8f0",
  },
  title: {
    color: "#152556",
    fontSize: "clamp(30px, 5vw, 44px)",
    margin: 0,
    fontWeight: 900,
  },
  subtitle: {
    color: "#89723d",
    marginTop: 8,
    marginBottom: 24,
  },
  text: {
    color: "#334155",
    lineHeight: 1.7,
  },
  form: {
    display: "grid",
    gap: 14,
    marginTop: 24,
  },
  input: {
    padding: 15,
    borderRadius: 14,
    border: "1px solid #cbd5e1",
    fontSize: 15,
  },
  textarea: {
    padding: 15,
    borderRadius: 14,
    border: "1px solid #cbd5e1",
    fontSize: 15,
    resize: "vertical",
  },
  button: {
    background: "#152556",
    color: "#fff",
    border: 0,
    borderRadius: 16,
    padding: "16px 18px",
    fontWeight: 800,
    cursor: "pointer",
  },
  message: {
    marginTop: 18,
    color: "#152556",
    fontWeight: 700,
  },
  contact: {
    marginTop: 22,
    color: "#64748b",
  },
};
